// import React, { useState, useEffect, useCallback } from 'react';
// import { getQuotations, updateQuotation, deleteQuotation } from '../utils/api';
// import toast from 'react-hot-toast';

// const STATUSES = ['all', 'New', 'Contacted', 'In Progress', 'Closed'];
// const BADGE = { New: 'badge-new', Contacted: 'badge-contacted', 'In Progress': 'badge-progress', Closed: 'badge-closed' };

// export default function QuotationsPage() {
//   const [quotations, setQuotations] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [status, setStatus] = useState('all');
//   const [search, setSearch] = useState('');
//   const [searchInput, setSearchInput] = useState('');
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [selected, setSelected] = useState(null);
//   const [updating, setUpdating] = useState(null);

//   const fetch = useCallback(() => {
//     setLoading(true);
//     getQuotations({ page, limit: 10, status: status === 'all' ? undefined : status, search: search || undefined })
//       .then(r => { setQuotations(r.data.data); setTotalPages(r.data.totalPages); setTotal(r.data.total); })
//       .catch(() => toast.error('Failed to load'))
//       .finally(() => setLoading(false));
//   }, [page, status, search]);

//   useEffect(() => { fetch(); }, [fetch]);
//   useEffect(() => { setPage(1); }, [status, search]);

//   const handleStatusChange = async (id, newStatus) => {
//     setUpdating(id);
//     try {
//       await updateQuotation(id, { status: newStatus });
//       toast.success('Status updated');
//       fetch();
//       if (selected?._id === id) setSelected(p => ({ ...p, status: newStatus }));
//     } catch { toast.error('Update failed'); }
//     finally { setUpdating(null); }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Delete this quotation request?')) return;
//     try {
//       await deleteQuotation(id);
//       toast.success('Deleted');
//       if (selected?._id === id) setSelected(null);
//       fetch();
//     } catch { toast.error('Delete failed'); }
//   };

//   return (
//     <div className="space-y-5">
//       <div className="flex items-center justify-between flex-wrap gap-4">
//         <div>
//           <h1 className="font-display text-xl font-semibold text-surface-100">Quotation Requests</h1>
//           <p className="text-surface-500 text-sm mt-0.5">{total} total requests</p>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="card p-4 flex flex-col sm:flex-row gap-3">
//         <div className="flex gap-1.5 flex-wrap">
//           {STATUSES.map(s => (
//             <button key={s} onClick={() => setStatus(s)}
//               className={`px-3 py-1.5 rounded text-xs font-medium transition-colors ${status === s ? 'bg-brand-400 text-surface-900' : 'bg-surface-700 text-surface-400 hover:text-surface-200'}`}>
//               {s}
//             </button>
//           ))}
//         </div>
//         <form onSubmit={e => { e.preventDefault(); setSearch(searchInput); }} className="flex gap-2 ml-auto">
//           <input value={searchInput} onChange={e => setSearchInput(e.target.value)} placeholder="Search by name, phone…" className="input w-48 py-1.5" />
//           <button type="submit" className="btn-secondary py-1.5 px-3">Search</button>
//           {search && <button type="button" onClick={() => { setSearch(''); setSearchInput(''); }} className="btn-secondary py-1.5 px-2">✕</button>}
//         </form>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
//         {/* List */}
//         <div className="lg:col-span-2 card overflow-hidden">
//           <div className="divide-y divide-surface-700">
//             {loading ? (
//               [...Array(5)].map((_, i) => (
//                 <div key={i} className="p-4 animate-pulse flex gap-3">
//                   <div className="flex-1 space-y-2">
//                     <div className="h-4 bg-surface-700 rounded w-1/3" />
//                     <div className="h-3 bg-surface-700 rounded w-1/2" />
//                   </div>
//                 </div>
//               ))
//             ) : quotations.length === 0 ? (
//               <div className="p-12 text-center text-surface-600 text-sm">No quotations found</div>
//             ) : quotations.map(q => (
//               <div key={q._id}
//                 className={`p-4 cursor-pointer hover:bg-surface-700/30 transition-colors ${selected?._id === q._id ? 'bg-surface-700/50 border-l-2 border-brand-400' : ''}`}
//                 onClick={() => setSelected(q)}>
//                 <div className="flex items-start justify-between gap-2">
//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center gap-2 flex-wrap">
//                       <p className="text-surface-200 font-medium text-sm">{q.name}</p>
//                       <span className={BADGE[q.status] || 'badge-closed'}>{q.status}</span>
//                     </div>
//                     <p className="text-surface-500 text-xs mt-1">{q.projectType} · {q.location}</p>
//                     <p className="text-surface-600 text-xs mt-0.5">{q.phone} · {q.email}</p>
//                   </div>
//                   <p className="text-surface-600 text-xs flex-shrink-0">{new Date(q.createdAt).toLocaleDateString('en-IN')}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//           {totalPages > 1 && (
//             <div className="flex items-center justify-between px-4 py-3 border-t border-surface-700">
//               <p className="text-surface-500 text-xs">Page {page} of {totalPages}</p>
//               <div className="flex gap-1">
//                 <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">← Prev</button>
//                 <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">Next →</button>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Detail panel */}
//         <div className="card p-5">
//           {selected ? (
//             <div className="space-y-4">
//               <div className="flex items-start justify-between">
//                 <h3 className="text-surface-200 font-semibold">{selected.name}</h3>
//                 <span className={BADGE[selected.status] || 'badge-closed'}>{selected.status}</span>
//               </div>
//               <div className="space-y-2 text-sm">
//                 {[
//                   ['Phone', selected.phone, `tel:${selected.phone}`],
//                   ['Email', selected.email, `mailto:${selected.email}`],
//                   ['Location', selected.location],
//                   ['Project Type', selected.projectType],
//                   ['Budget', selected.budget],
//                   ['Submitted', new Date(selected.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })]
//                 ].filter(([, v]) => v).map(([label, value, href]) => (
//                   <div key={label} className="flex gap-2">
//                     <span className="text-surface-500 w-24 flex-shrink-0">{label}</span>
//                     {href
//                       ? <a href={href} className="text-brand-400 hover:underline truncate">{value}</a>
//                       : <span className="text-surface-300">{value}</span>
//                     }
//                   </div>
//                 ))}
//               </div>
//               {selected.message && (
//                 <div>
//                   <p className="text-surface-500 text-xs uppercase tracking-wide mb-1">Message</p>
//                   <p className="text-surface-300 text-sm bg-surface-700/50 p-3 rounded leading-relaxed">{selected.message}</p>
//                 </div>
//               )}
//               <div>
//                 <p className="text-surface-500 text-xs uppercase tracking-wide mb-2">Update Status</p>
//                 <div className="grid grid-cols-2 gap-2">
//                   {['New', 'Contacted', 'In Progress', 'Closed'].map(s => (
//                     <button key={s} onClick={() => handleStatusChange(selected._id, s)} disabled={updating === selected._id || selected.status === s}
//                       className={`py-1.5 text-xs rounded border transition-all disabled:opacity-50 ${selected.status === s ? 'border-brand-400 text-brand-400 bg-brand-400/10' : 'border-surface-600 text-surface-400 hover:border-surface-500 hover:text-surface-200'}`}>
//                       {s}
//                     </button>
//                   ))}
//                 </div>
//               </div>
//               <button onClick={() => handleDelete(selected._id)} className="btn-danger w-full py-2 text-xs">Delete Request</button>
//             </div>
//           ) : (
//             <div className="h-48 flex items-center justify-center text-surface-600 text-sm">
//               Select a quotation to view details
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


// import React, { useState, useEffect, useCallback } from 'react';
// import { Search, Trash2, ChevronDown, Phone, Mail, MapPin, MessageSquare } from 'lucide-react';
// import { getAdminQuotations, updateQuotationStatus, deleteQuotation, getQuotationStats } from '../utils/api';
// import toast from 'react-hot-toast';
// import ConfirmModal from '../components/ConfirmModal';

// const STATUS_OPTIONS = ['new', 'contacted', 'in_progress', 'closed'];
// const STATUS_COLORS = {
//   new:         'bg-blue-500/10 text-blue-400 border-blue-500/20',
//   contacted:   'bg-green-500/10 text-green-400 border-green-500/20',
//   in_progress: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
//   closed:      'bg-white/5 text-white/40 border-white/10',
// };

// function StatBadge({ label, value, color }) {
//   return (
//     <div className={`card p-4 border ${color}`}>
//       <div className="text-2xl font-bold text-white">{value}</div>
//       <div className="text-xs text-white/40 mt-0.5 capitalize">{label}</div>
//     </div>
//   );
// }

// export default function QuotationsPage() {
//   const [quotations, setQuotations] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [meta, setMeta] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [statusFilter, setStatusFilter] = useState('');
//   const [page, setPage] = useState(1);
//   const [deleteId, setDeleteId] = useState(null);
//   const [expanded, setExpanded] = useState(null);
//   const [updatingId, setUpdatingId] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const [qRes, sRes] = await Promise.all([
//         getAdminQuotations({ search, status: statusFilter, page, per_page: 15 }),
//         getQuotationStats(),
//       ]);
//       setQuotations(qRes.data.data || []);
//       setMeta(qRes.data.meta || {});
//       setStats(sRes.data.data);
//     } catch { toast.error('Failed to load quotations'); }
//     finally { setLoading(false); }
//   }, [search, statusFilter, page]);

//   useEffect(() => {
//     const t = setTimeout(fetchData, search ? 400 : 0);
//     return () => clearTimeout(t);
//   }, [fetchData]);

//   const handleStatusChange = async (id, newStatus) => {
//     setUpdatingId(id);
//     try {
//       await updateQuotationStatus(id, { status: newStatus });
//       setQuotations(prev => prev.map(q => q.id === id ? { ...q, status: newStatus } : q));
//       toast.success('Status updated');
//     } catch { toast.error('Failed to update status'); }
//     finally { setUpdatingId(null); }
//   };

//   const handleDelete = async () => {
//     try {
//       await deleteQuotation(deleteId);
//       toast.success('Quotation deleted');
//       setDeleteId(null);
//       fetchData();
//     } catch { toast.error('Failed to delete'); }
//   };

//   return (
//     <div>
//       <div className="mb-6">
//         <h1 className="text-xl font-semibold text-white">Quotations</h1>
//         <p className="text-white/40 text-sm mt-0.5">Manage incoming project quotation requests</p>
//       </div>

//       {/* Stats */}
//       {stats && (
//         <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-6">
//           <StatBadge label="Total" value={stats.total} color="border-white/8" />
//           <StatBadge label="New" value={stats.new} color="border-blue-500/20" />
//           <StatBadge label="Contacted" value={stats.contacted} color="border-green-500/20" />
//           <StatBadge label="In Progress" value={stats.in_progress} color="border-yellow-500/20" />
//           <StatBadge label="Closed" value={stats.closed} color="border-white/5" />
//         </div>
//       )}

//       {/* Filters */}
//       <div className="card p-4 mb-4 flex flex-col sm:flex-row gap-3">
//         <div className="relative flex-1">
//           <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
//           <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Search by name, email or phone..." className="input pl-9 py-2" />
//         </div>
//         <select value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }} className="input py-2 w-full sm:w-44">
//           <option value="">All Statuses</option>
//           {STATUS_OPTIONS.map(s => <option key={s} value={s} className="capitalize">{s.replace('_', ' ')}</option>)}
//         </select>
//       </div>

//       {/* List */}
//       <div className="space-y-2">
//         {loading ? (
//           [...Array(5)].map((_, i) => (
//             <div key={i} className="card p-4">
//               <div className="skeleton h-4 w-full rounded mb-2" />
//               <div className="skeleton h-3 w-2/3 rounded" />
//             </div>
//           ))
//         ) : quotations.length === 0 ? (
//           <div className="card p-12 text-center">
//             <MessageSquare size={32} className="mx-auto mb-3 text-white/10" />
//             <p className="text-white/30 text-sm">No quotations found</p>
//           </div>
//         ) : (
//           quotations.map(q => (
//             <div key={q.id} className="card overflow-hidden">
//               <div
//                 className="flex items-center justify-between p-4 cursor-pointer hover:bg-white/2 transition-colors"
//                 onClick={() => setExpanded(expanded === q.id ? null : q.id)}
//               >
//                 <div className="flex items-center gap-4 min-w-0">
//                   <div className="w-9 h-9 rounded-full bg-primary-500/10 flex items-center justify-center text-primary-400 font-semibold text-sm shrink-0">
//                     {q.name[0]}
//                   </div>
//                   <div className="min-w-0">
//                     <div className="font-medium text-white text-sm">{q.name}</div>
//                     <div className="text-xs text-white/30 flex items-center gap-2 mt-0.5">
//                       <span>{q.project_type}</span>
//                       <span>·</span>
//                       <span className="flex items-center gap-1"><MapPin size={9} />{q.location}</span>
//                       {q.budget && <><span>·</span><span>{q.budget}</span></>}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-2 ml-3 shrink-0">
//                   <span className={`badge border ${STATUS_COLORS[q.status] || STATUS_COLORS.closed} capitalize hidden sm:flex`}>
//                     {q.status.replace('_', ' ')}
//                   </span>
//                   <ChevronDown size={14} className={`text-white/30 transition-transform ${expanded === q.id ? 'rotate-180' : ''}`} />
//                 </div>
//               </div>

//               {expanded === q.id && (
//                 <div className="border-t border-white/8 p-4 bg-surface-700/30">
//                   <div className="grid sm:grid-cols-2 gap-4 mb-4">
//                     <div className="space-y-2">
//                       <div className="flex items-center gap-2 text-sm">
//                         <Mail size={12} className="text-primary-400" />
//                         <a href={`mailto:${q.email}`} className="text-white/70 hover:text-white">{q.email}</a>
//                       </div>
//                       <div className="flex items-center gap-2 text-sm">
//                         <Phone size={12} className="text-primary-400" />
//                         <a href={`tel:${q.phone}`} className="text-white/70 hover:text-white">{q.phone}</a>
//                       </div>
//                     </div>
//                     <div className="text-xs text-white/30">
//                       Submitted: {new Date(q.created_at).toLocaleString('en-IN')}
//                     </div>
//                   </div>

//                   {q.message && (
//                     <div className="bg-surface-800 rounded-lg p-3 mb-4">
//                       <p className="text-white/40 text-xs uppercase tracking-wider mb-1">Message</p>
//                       <p className="text-white/70 text-sm">{q.message}</p>
//                     </div>
//                   )}

//                   <div className="flex items-center gap-2 flex-wrap">
//                     <span className="text-white/40 text-xs">Update status:</span>
//                     {STATUS_OPTIONS.map(s => (
//                       <button
//                         key={s}
//                         disabled={q.status === s || updatingId === q.id}
//                         onClick={() => handleStatusChange(q.id, s)}
//                         className={`badge border capitalize cursor-pointer transition-all hover:opacity-80 disabled:cursor-default ${
//                           q.status === s ? STATUS_COLORS[s] + ' opacity-100' : 'border-white/10 text-white/40 hover:border-white/20'
//                         }`}
//                       >
//                         {s.replace('_', ' ')}
//                       </button>
//                     ))}
//                     <div className="ml-auto">
//                       <button onClick={() => setDeleteId(q.id)} className="btn-danger py-1 px-2 text-xs">
//                         <Trash2 size={11} /> Delete
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))
//         )}
//       </div>

//       {meta.last_page > 1 && (
//         <div className="flex justify-center gap-2 mt-4">
//           <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">Prev</button>
//           <span className="text-white/40 text-xs self-center">Page {meta.current_page} of {meta.last_page}</span>
//           <button onClick={() => setPage(p => Math.min(meta.last_page, p + 1))} disabled={page === meta.last_page} className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">Next</button>
//         </div>
//       )}

//       <ConfirmModal open={!!deleteId} title="Delete Quotation" message="Delete this quotation request permanently?" onConfirm={handleDelete} onCancel={() => setDeleteId(null)} danger />
//     </div>
//   );
// }



import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Search, Trash2, ChevronDown, Phone, Mail, MapPin, MessageSquare } from 'lucide-react';
import { getAdminQuotations, updateQuotationStatus, deleteQuotation, getQuotationStats } from '../utils/api';
import toast from 'react-hot-toast';
import ConfirmModal from '../components/ConfirmModal';

const STATUS_OPTIONS = ['new', 'contacted', 'in_progress', 'closed'];
const STATUS_COLORS = {
  new:         'bg-blue-500/10 text-blue-400 border-blue-500/20',
  contacted:   'bg-green-500/10 text-green-400 border-green-500/20',
  in_progress: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  closed:      'bg-white/5 text-white/40 border-white/10',
};

/* ── Keyframes ── */
const STYLES = `
  @keyframes statPop {
    from { opacity: 0; transform: scale(0.88) translateY(10px); }
    to   { opacity: 1; transform: scale(1) translateY(0); }
  }
  @keyframes rowSlide {
    from { opacity: 0; transform: translateX(-10px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes expandDown {
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes headerIn {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

/* ── Count-up hook ── */
function useCountUp(target, enabled = true) {
  const [val, setVal] = useState(0);
  const raf = useRef(null);
  useEffect(() => {
    if (!enabled || !target) return;
    const start = performance.now();
    const dur = 900;
    const ease = t => 1 - Math.pow(1 - t, 3);
    const tick = now => {
      const t = Math.min((now - start) / dur, 1);
      setVal(Math.round(ease(t) * target));
      if (t < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [target, enabled]);
  return val;
}

/* ── Animated stat badge ── */
const STAT_COLORS = {
  Total:       { border: 'border-white/10',       text: 'text-white',        bg: '' },
  New:         { border: 'border-blue-500/25',     text: 'text-blue-400',     bg: 'bg-blue-500/5' },
  Contacted:   { border: 'border-green-500/25',    text: 'text-green-400',    bg: 'bg-green-500/5' },
  'In Progress':{ border: 'border-yellow-500/25', text: 'text-yellow-400',   bg: 'bg-yellow-500/5' },
  Closed:      { border: 'border-white/8',         text: 'text-white/40',     bg: '' },
};

function StatBadge({ label, value, delay = 0, ready = false }) {
  const animated = useCountUp(value, ready);
  const c = STAT_COLORS[label] || STAT_COLORS.Total;
  return (
    <div
      className={`card p-4 border ${c.border} ${c.bg}`}
      style={{ animation: `statPop 0.5s cubic-bezier(0.34,1.56,0.64,1) both`, animationDelay: `${delay}ms` }}
    >
      <div className={`text-2xl font-bold tabular-nums ${c.text}`}>{animated}</div>
      <div className="text-xs text-white/40 mt-0.5 capitalize">{label}</div>
    </div>
  );
}

export default function QuotationsPage() {
  const [quotations, setQuotations] = useState([]);
  const [stats, setStats] = useState(null);
  const [statsReady, setStatsReady] = useState(false);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [updatingId, setUpdatingId] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [qRes, sRes] = await Promise.all([
        getAdminQuotations({ search, status: statusFilter, page, per_page: 15 }),
        getQuotationStats(),
      ]);
      setQuotations(qRes.data.data || []);
      setMeta(qRes.data.meta || {});
      setStats(sRes.data.data);
      // Trigger count-up after a short pause so animation is visible
      setTimeout(() => setStatsReady(true), 100);
    } catch { toast.error('Failed to load quotations'); }
    finally { setLoading(false); }
  }, [search, statusFilter, page]);

  useEffect(() => {
    setStatsReady(false);
    const t = setTimeout(fetchData, search ? 400 : 0);
    return () => clearTimeout(t);
  }, [fetchData]);

  const handleStatusChange = async (id, newStatus) => {
    setUpdatingId(id);
    try {
      await updateQuotationStatus(id, { status: newStatus });
      setQuotations(prev => prev.map(q => q.id === id ? { ...q, status: newStatus } : q));
      toast.success('Status updated');
    } catch { toast.error('Failed to update status'); }
    finally { setUpdatingId(null); }
  };

  const handleDelete = async () => {
    try {
      await deleteQuotation(deleteId);
      toast.success('Quotation deleted');
      setDeleteId(null);
      fetchData();
    } catch { toast.error('Failed to delete'); }
  };

  return (
    <div>
      <style>{STYLES}</style>

      {/* Header */}
      <div
        className="mb-6"
        style={{ animation: 'headerIn 0.35s ease both' }}
      >
        <h1 className="text-xl font-semibold text-white">Quotations</h1>
        <p className="text-white/40 text-sm mt-0.5">Manage incoming project quotation requests</p>
      </div>

      {/* Stats */}
      {stats && (
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-6">
          <StatBadge label="Total"       value={stats.total}       delay={0}   ready={statsReady} />
          <StatBadge label="New"         value={stats.new}         delay={60}  ready={statsReady} />
          <StatBadge label="Contacted"   value={stats.contacted}   delay={120} ready={statsReady} />
          <StatBadge label="In Progress" value={stats.in_progress} delay={180} ready={statsReady} />
          <StatBadge label="Closed"      value={stats.closed}      delay={240} ready={statsReady} />
        </div>
      )}

      {/* Filters */}
      <div
        className="card p-4 mb-4 flex flex-col sm:flex-row gap-3"
        style={{ animation: 'headerIn 0.4s ease both', animationDelay: '80ms' }}
      >
        <div className="relative flex-1">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
          <input
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }}
            placeholder="Search by name, email or phone..."
            className="input pl-9 py-2"
          />
        </div>
        <select
          value={statusFilter}
          onChange={e => { setStatusFilter(e.target.value); setPage(1); }}
          className="input py-2 w-full sm:w-44"
        >
          <option value="">All Statuses</option>
          {STATUS_OPTIONS.map(s => (
            <option key={s} value={s} className="capitalize">{s.replace('_', ' ')}</option>
          ))}
        </select>
      </div>

      {/* List */}
      <div className="space-y-2">
        {loading ? (
          [...Array(5)].map((_, i) => (
            <div key={i} className="card p-4" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="skeleton h-4 w-full rounded mb-2" />
              <div className="skeleton h-3 w-2/3 rounded" />
            </div>
          ))
        ) : quotations.length === 0 ? (
          <div
            className="card p-12 text-center"
            style={{ animation: 'statPop 0.4s ease both' }}
          >
            <MessageSquare size={32} className="mx-auto mb-3 text-white/10" />
            <p className="text-white/30 text-sm">No quotations found</p>
          </div>
        ) : (
          quotations.map((q, idx) => (
            <div
              key={q.id}
              className="card overflow-hidden"
              style={{
                animation: 'rowSlide 0.35s cubic-bezier(0.22,1,0.36,1) both',
                animationDelay: `${idx * 45}ms`,
              }}
            >
              {/* Row header */}
              <div
                className="flex items-center justify-between p-4 cursor-pointer hover:bg-white/2 transition-colors"
                onClick={() => setExpanded(expanded === q.id ? null : q.id)}
              >
                <div className="flex items-center gap-4 min-w-0">
                  {/* Avatar */}
                  <div className="w-9 h-9 rounded-full bg-primary-500/10 flex items-center justify-center text-primary-400 font-semibold text-sm shrink-0">
                    {q.name[0]}
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium text-white text-sm">{q.name}</div>
                    <div className="text-xs text-white/30 flex items-center gap-2 mt-0.5">
                      <span>{q.project_type}</span>
                      <span>·</span>
                      <span className="flex items-center gap-1"><MapPin size={9} />{q.location}</span>
                      {q.budget && <><span>·</span><span>{q.budget}</span></>}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 ml-3 shrink-0">
                  <span className={`badge border ${STATUS_COLORS[q.status] || STATUS_COLORS.closed} capitalize hidden sm:flex`}>
                    {q.status.replace('_', ' ')}
                  </span>
                  <ChevronDown
                    size={14}
                    className="text-white/30 transition-transform duration-200"
                    style={{ transform: expanded === q.id ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  />
                </div>
              </div>

              {/* Expanded detail */}
              {expanded === q.id && (
                <div
                  className="border-t border-white/8 p-4 bg-white/2"
                  style={{ animation: 'expandDown 0.25s ease both' }}
                >
                  <div className="grid sm:grid-cols-2 gap-4 mb-4">
                    <div className="space-y-2">
                      <div className="flex items-center gap-2 text-sm">
                        <Mail size={12} className="text-primary-400" />
                        <a href={`mailto:${q.email}`} className="text-white/70 hover:text-white transition-colors">{q.email}</a>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <Phone size={12} className="text-primary-400" />
                        <a href={`tel:${q.phone}`} className="text-white/70 hover:text-white transition-colors">{q.phone}</a>
                      </div>
                    </div>
                    <div className="text-xs text-white/30">
                      Submitted: {new Date(q.created_at).toLocaleString('en-IN')}
                    </div>
                  </div>

                  {q.message && (
                    <div className="bg-white/3 rounded-lg p-3 mb-4 border border-white/5">
                      <p className="text-white/40 text-xs uppercase tracking-wider mb-1">Message</p>
                      <p className="text-white/70 text-sm">{q.message}</p>
                    </div>
                  )}

                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-white/40 text-xs">Update status:</span>
                    {STATUS_OPTIONS.map(s => (
                      <button
                        key={s}
                        disabled={q.status === s || updatingId === q.id}
                        onClick={() => handleStatusChange(q.id, s)}
                        className={`badge border capitalize cursor-pointer transition-all hover:opacity-80 disabled:cursor-default ${
                          q.status === s
                            ? STATUS_COLORS[s] + ' opacity-100'
                            : 'border-white/10 text-white/40 hover:border-white/20'
                        }`}
                      >
                        {updatingId === q.id && q.status !== s ? '…' : s.replace('_', ' ')}
                      </button>
                    ))}
                    <div className="ml-auto">
                      <button onClick={() => setDeleteId(q.id)} className="btn-danger py-1 px-2 text-xs flex items-center gap-1">
                        <Trash2 size={11} /> Delete
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {meta.last_page > 1 && (
        <div
          className="flex justify-center gap-2 mt-4"
          style={{ animation: 'headerIn 0.3s ease both', animationDelay: '200ms' }}
        >
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className="btn-secondary py-1 px-3 text-xs disabled:opacity-40"
          >
            Prev
          </button>
          <span className="text-white/40 text-xs self-center">
            Page {meta.current_page} of {meta.last_page}
          </span>
          <button
            onClick={() => setPage(p => Math.min(meta.last_page, p + 1))}
            disabled={page === meta.last_page}
            className="btn-secondary py-1 px-3 text-xs disabled:opacity-40"
          >
            Next
          </button>
        </div>
      )}

      <ConfirmModal
        open={!!deleteId}
        title="Delete Quotation"
        message="Delete this quotation request permanently?"
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
        danger
      />
    </div>
  );
}